import { localDateToMoment, TARJETA, TARJETA_COLORS } from "./tarjeta.utils";
import tarjeta_personal from "../../../assets/img/tarjeta/tarjeta_personal.png";
import tarjeta_corporativo from "../../../assets/img/tarjeta/tarjeta_corporativo.png";
import { ReactComponent as IconCerrar } from "../../../assets/img/icon/icon_cerrar_verde.svg";
import { ReactComponent as IconBeneficio } from "../../../assets/img/icon/icon_beneficios.svg";
import { useHistory } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useUser } from "../../../custom-hooks/useUser";
import { getTarjetaByCdCliente, getTarjetaByCedula } from "./tarjeta.service";
import Alerts from "../../../util/Alerts";
import { useSelector } from "react-redux";
import { EFI_MODULES } from "../../../util/General";
import { useWindowSizeStore } from "../../../store/window-size.store";

export const Tarjeta = () => {
    const history = useHistory();
    const user = useUser();
    const alert = useRef(null);
    const module = useSelector(state => state["mod"]).mod;

    const { width, height } = useWindowSizeStore();

    const [tarjeta, setTarjeta] = useState(TARJETA);
    const [rotateNeeded, setRotateNeeded] = useState(false);

    useEffect(() => {
        if (module === EFI_MODULES.VAM && !user.cedula) return;
        if (module === EFI_MODULES.GEN && !user.cdCliente) return;

        (module === EFI_MODULES.VAM ? getTarjetaByCedula(user.cedula) : getTarjetaByCdCliente(user.cdCliente))
            .then(setTarjeta)
            .catch(alert.current.handle_error);
    }, [user.cedula]);

    useEffect(() => {
        const hasToRotate = width < height;
        if (hasToRotate !== rotateNeeded) setRotateNeeded(hasToRotate);
    }, [width, height]);

    const onCerrar = () => history.push(`/`);
    const onBeneficio = () => {
        window.open(`https://www.canva.com/design/DAGKX6op4gU/9fCtRhhGALp2JYqmPqWYAw/view?utm_content=DAGKX6op4gU&utm_campaign=designshare&utm_medium=link&utm_source=editor`, 'beneficios');
    };

    return (
        <div className={`tarjeta ${rotateNeeded ? "tarjeta-rotated" : ""}`}>
            <Alerts ref={alert} />
            <div className={`to-rotate ${rotateNeeded ? "" : "container-fluid container-lg"}`}>
                <div className={"tarjeta__container"}>
                    <div className="tarjeta__body" style={{ background: TARJETA_COLORS.green }}>
                        <div className={"tarjeta__datos py-3 pl-3 py-md-5 pl-md-5"}>
                            <div className="tarjeta__title mb-2 pb-2 mb-lg-5 pb-lg-5">
                                <h1 className={"d-inline mr-3 tarjeta__title--first"}>Tarjeta</h1>&nbsp;
                                <h3 className={"d-inline tarjeta__title--second"}>de</h3>
                                <h1 className={"mt-1 mb-0 tarjeta__title--third"}>BENEFICIOS</h1>
                            </div>
                            <div>
                                <TarjetaDatoPersonal
                                    title={module === EFI_MODULES.VAM ? "Asegurado:" : "Contratante:"}
                                    text={tarjeta.nombreCliente}
                                    modifier={"asegurado"}
                                />
                                <div className="tarjeta__border-bottom" />
                                <TarjetaDatoPersonal title={"CI:"} text={tarjeta.cedula} modifier={"cedula"} />
                            </div>
                            <TarjetaDatoPersonal
                                title={"Cliente desde:"}
                                text={localDateToMoment(tarjeta.fechaClienteDesde)}
                                modifier={"fecha"}
                            />
                        </div>
                        <div className={"tarjeta__image"}>
                            <img src={tarjeta.corporativo ? tarjeta_corporativo : tarjeta_personal} alt="" />
                        </div>
                    </div>
                    <div className="tarjeta__menu">
                        <TarjetaMenuIcon Icon={IconCerrar} title={"Cerrar"} onClick={onCerrar} />
                        <TarjetaMenuIcon Icon={IconBeneficio} title={"Beneficios"} onClick={onBeneficio} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const TarjetaMenuIcon = ({ Icon, title, onClick }) => {
    return (
        <div className={"tarjeta__menu-icon"} onClick={onClick}>
            <Icon />
            <span className={"mt-2"}>{title}</span>
        </div>
    );
};

const TarjetaDatoPersonal = ({ title, text, modifier }) => {
    return (
        <div className={`tarjeta__dato-personal ${modifier ?? ""}`}>
            <h4 className={"title"}>{title}</h4>
            <h1 className={"text"}>{text}</h1>
        </div>
    );
};
